<div class="flex items-end justify-center gap-4">
  <form>
    <div class="space-y-12">
      <div class="border-b border-gray-900/10 pb-12">
        <h1 class="text-2xl font-semibold text-gray-900 text-center">
          Formulaire de Génération de Widget Url
        </h1>

        <div class="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
          <div class="sm:col-span-3">
            <label
              for="environement"
              class="block text-sm font-medium leading-6 text-gray-900"
            >
              Environnement
            </label>
            <div class="mt-2">
              <select
                id="environement"
                name="environement"
                (ngModelChange)="onEnvChange($event)"
                [(ngModel)]="openBankingEnv"
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-oney sm:max-w-xs sm:text-sm sm:leading-6"
              >
                <option>dev</option>
                <option>preprod</option>
                <option>local</option>
              </select>
              <div class="flex flex-row" *ngIf="openBankingEnv === 'local'">
                <input
                  name="origin"
                  [(ngModel)]="openBankingLocalFrontendOrigin"
                  placeholder="Specify origin"
                  class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-oney sm:max-w-xs sm:text-sm sm:leading-6"
                />
              </div>
            </div>
          </div>
          <div class="col-span-full">
            <label
              for="azure-token"
              class="block text-sm font-medium leading-6 text-gray-900"
              >Azure token</label
            >
            <div class="mt-2">
              <textarea
                id="azure-token"
                name="azure-token"
                rows="3"
                [(ngModel)]="azureToken"
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-oney sm:text-sm sm:leading-6"
              ></textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="border-b border-gray-900/10 pb-12">
        <h2 class="text-base font-semibold leading-7 text-gray-900">
          Context informations
        </h2>
        <div class="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
          <div class="col-span-full">
            <label
              for="restore-url"
              class="block text-sm font-medium leading-6 text-gray-900"
              >Restore URL</label
            >
            <div class="mt-2">
              <input
                type="text"
                name="restore-url"
                id="restore-url"
                [(ngModel)]="restoreUrl"
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-oney sm:text-sm sm:leading-6"
              />
            </div>
          </div>
          <div class="sm:col-span-3">
            <label
              for="external-reference"
              class="block text-sm font-medium leading-6 text-gray-900"
              >External reference</label
            >
            <div class="mt-2">
              <input
                type="text"
                name="external-reference"
                id="external-reference"
                [(ngModel)]="externalReference"
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-oney sm:text-sm sm:leading-6"
              />
            </div>
          </div>

          <div class="sm:col-span-3">
            <label
              for="financing-amount"
              class="block text-sm font-medium leading-6 text-gray-900"
              >Financing anount</label
            >
            <div class="mt-2">
              <input
                type="number"
                name="financing-amount"
                id="financing-amount"
                [(ngModel)]="financingAmount"
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-oney sm:text-sm sm:leading-6"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="border-b border-gray-900/10 pb-12">
        <h2 class="text-base font-semibold leading-7 text-gray-900">
          Customer informations
        </h2>
        <div class="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
          <div class="sm:col-span-3">
            <label
              for="first-name"
              class="block text-sm font-medium leading-6 text-gray-900"
              >First name</label
            >
            <div class="mt-2">
              <input
                type="text"
                name="first-name"
                id="first-name"
                autocomplete="given-name"
                [(ngModel)]="firstName"
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-oney sm:text-sm sm:leading-6"
              />
            </div>
          </div>

          <div class="sm:col-span-3">
            <label
              for="last-name"
              class="block text-sm font-medium leading-6 text-gray-900"
              >Last name</label
            >
            <div class="mt-2">
              <input
                type="text"
                name="last-name"
                id="last-name"
                autocomplete="family-name"
                [(ngModel)]="lastName"
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-oney sm:text-sm sm:leading-6"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-6 flex items-center justify-end gap-x-6">
      <button
        (click)="onUrlSubmit()"
        class="rounded-md bg-oney px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-oney/70"
      >
        Générer l'url
      </button>
    </div>
  </form>
</div>

<div
  class="relative z-10"
  aria-labelledby="modal-title"
  role="dialog"
  aria-modal="true"
  *ngIf="isLoading"
>
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div
      class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"
    >
      <div
        class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:p-6"
      >
        <lucide-icon
          name="loader-2"
          class="w-16 h-16 text-oney animate-spin"
        ></lucide-icon>
      </div>
    </div>
  </div>
</div>
